import React from 'react';
import HeroSection from './HeroSection';
import Partners from './Partners';
import PricingSection from './PricingSection';
import About from './About';
import ContactForm from './ContactForm';

function AssessmentHome() {
    return (
        <>
            <div className="mt-0">
                <HeroSection />
                <About />
                <PricingSection />
                
                <ContactForm />
                <Partners />
                {/* <Banner /> */}
            </div>

        </>
    );
}

export default AssessmentHome;
